<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre5 sgc-15 sgc-410 sigilNotInTOC" id="heading_id_2">CONTENTS</h1>
<p class="calibre9"><a href="#/Text/Chapter01">1. Pardoner’s Place—9:00 A.M.</a></p>
<p class="calibre1"><span href="#/Text/Chapter02" title="Link target outside of Sample">2. Preparation for a Party</span></p>
<p class="calibre1"><span href="#/Text/Chapter03" title="Link target outside of Sample">3. Birthday Honours</span></p>
<p class="calibre1"><span href="#/Text/Chapter04" title="Link target outside of Sample">4. Catastrophe</span></p>
<p class="calibre1"><span href="#/Text/Chapter05" title="Link target outside of Sample">5. Questions of Adherence</span></p>
<p class="calibre1"><span href="#/Text/Chapter06" title="Link target outside of Sample">6. On the Scent</span></p>
<p class="calibre1"><span href="#/Text/Chapter07" title="Link target outside of Sample">7. Re-entry of Mr. Marchant</span></p>
<p class="calibre1"><span href="#/Text/Chapter08" title="Link target outside of Sample">8. Pattern Completed</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?053f4c96